
import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";

export type TMessages = {
  content: string;
  type: 'left' | 'right';
  isActionable: boolean;
  isLastClicked: boolean;
};

async function analyzeChat(
  messages: { content: string; type: "left" | "right"; isActionable: boolean }[],
  message: string,
  studentId?: string,
  report?: any,
  reportSectionsUpdateStatus?: any,
  model?: string,
  contentResult?: string | null,
  sectionDescription?: { [key: string]: string },
  limitSectionWord: TPlainObject = {}
) {
  try {
    const history = JSON.stringify(
      messages.map((msg) => `${msg.type === "left" ? "System" : "User"}: ${msg.content}`)
    );

    const requestBody: any = {
      studentId,
      history,
      message,
      ...(model ? { model } : {}),
      contentResult,
    };

    if (report) {
      requestBody.report = report;
    }

    if (reportSectionsUpdateStatus) {
      requestBody.contentupdate = reportSectionsUpdateStatus;
    }

    if (sectionDescription) {
      requestBody.sectionDescription = sectionDescription;
    }

    if (limitSectionWord) {
      requestBody.limitSectionWord = limitSectionWord;
    }

    const response = await axios.post(
      apiUrl("api/aria/chat", "aria"),
      requestBody,
      await getAuthHeader('aria')
    );

    if (response.data.status !== "OK") {
      throw new Error(response.data.message ?? "Unable to process the request");
    }

    return {
      status: true,
      data: response.data.data,
      contentResult: response.data.rubric,
      message: response.data.message,
    };
  } catch (err: any) {
    console.error("Error in analyzeChat:", err);
    return {
      status: false,
      message: err?.response?.data?.message ?? err.message ?? "An unexpected error occurred",
    };
  }
}

async function analyzeSupervisorChat(
  messages: { content: string; type: "left" | "right"; isActionable: boolean }[],
  message: string,
  studentId?: string,
  model?: string,
  student_reports_feedbacks?: any[],
  reports ?: any[],
) {
  try {
    const history = JSON.stringify(
      messages.map((msg) => `${msg.type === "left" ? "System" : "User"}: ${msg.content}`)
    );

    const requestBody: any = {
      studentId,
      history,
      message,
      ...(model ? { model } : {}),
      feedbacks: student_reports_feedbacks,
      reports
    };

    const response = await axios.post(
      apiUrl("api/aria/chat/supervisor", "aria"),
      requestBody,
      await getAuthHeader('aria')
    );

    if (response.data.status !== "OK") {
      throw new Error(response.data.message ?? "Unable to process the request");
    }

    return {
      status: true,
      data: response.data.data,
      contentResult: response.data.rubric,
      message: response.data.message,
    };
  } catch (err: any) {
    console.error("Error in analyzeChat:", err);

    return {
      status: false,
      message: err?.response?.data?.message ?? err.message ?? "An unexpected error occurred",
    };
  }
}

async function getAriaRating(userId: string, submissionId: string) {
  try {
    const response = await axios.get(
      apiUrl(`api/aria/rating/${submissionId}/${userId}`, "aria"),
      await getAuthHeader("aria")
    );

    if (!response.data.status) {
      throw new Error(response.data.message ?? "Failed to retrieve rating");
    }

    return {
      status: true,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (err: any) {
    console.error("Error in getAriaRating:", err);

    return {
      status: false,
      message: err.message ?? "An unexpected error occurred",
    };
  }
}

async function getAriaAllRatingBySubmissionId(submissionId: string) {
  try {
    const response = await axios.get(
      apiUrl(`api/aria/rating/submission/${submissionId}`, "aria"),
      await getAuthHeader("aria")
    );

    if (!response.data.status) {
      throw new Error(response.data.message ?? "Failed to retrieve rating");
    }

    return {
      status: true,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (err: any) {
    console.error("Error in getAriaRating:", err);

    return {
      status: false,
      message: err.message ?? "An unexpected error occurred",
    };
  }
}

async function rateARIAChat(userId: string, submissionId: string, feedback: string, like: boolean, source: string) {
  try {
    const response = await axios.post(
      apiUrl("api/aria/rating", "aria"),
      {
        userId,
        submissionId,
        feedback,
        like,
        source
      },
      await getAuthHeader('aria')
    );

    if (response.data.status !== "CREATED") {
      throw new Error(response.data.message ?? "Unable to process the request");
    }

    return {
      status: true,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (err: any) {
    console.error("Error in analyzeChat:", err);

    return {
      status: false,
      message: err?.response?.data?.message ?? err.message ?? "An unexpected error occurred",
    };
  }
}

const ApiARIAChat = {
  analyzeChat,
  analyzeSupervisorChat,
  getAriaRating,
  getAriaAllRatingBySubmissionId,
  rateARIAChat,
};

export default ApiARIAChat;
